declare namespace $ {

	type $shm_list_head__title_shm_wordstat_task_catalog_1 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_catalog['title'] >
		,
		ReturnType< $shm_list_head['title'] >
	>
	type $shm_list_head__filter_shm_wordstat_task_catalog_2 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_catalog['filter'] >
		,
		ReturnType< $shm_list_head['filter'] >
	>
	type $shm_list_head__Add_shm_wordstat_task_catalog_3 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_list_head['Add'] >
	>
	type $shm_list_head__Close_shm_wordstat_task_catalog_4 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_list_head['Close'] >
	>
	type $shm_list_head__Settings_shm_wordstat_task_catalog_5 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_list_head['Settings'] >
	>
	type $shm_ba_summary_card__title_shm_wordstat_task_catalog_6 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_wordstat_task_catalog_7 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_catalog['regular_tasks'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $shm_ba_summary_card__title_shm_wordstat_task_catalog_8 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_wordstat_task_catalog_9 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_catalog['regular_items'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $shm_ba_summary_card__title_shm_wordstat_task_catalog_10 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_wordstat_task_catalog_11 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_catalog['daily_requests'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $mol_view__sub_shm_wordstat_task_catalog_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_task_catalog_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_task_catalog_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_task_catalog_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_task_catalog_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_task_catalog_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_task_catalog_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_wordstat_task_catalog_19 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_catalog['task_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_wordstat_task_catalog_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_task_catalog_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_shm_wordstat_task_catalog_22 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_catalog['task_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_shm_wordstat_task_catalog_23 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_catalog['task_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_view__sub_shm_wordstat_task_catalog_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_task_catalog_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_task_catalog_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__title_shm_wordstat_task_catalog_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_wordstat_task_catalog_28 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_catalog['task_daily'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_view__sub_shm_wordstat_task_catalog_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_task_catalog_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_wordstat_task_catalog extends $mol_page {
		filter( next?: string ): string
		List_head( ): $shm_list_head
		regular_tasks( ): string
		Regular_tasks( ): $shm_ba_summary_card
		regular_items( ): string
		Regular_items( ): $shm_ba_summary_card
		daily_requests( ): string
		Daily_requests( ): $shm_ba_summary_card
		Stats( ): $mol_view
		Head_title( ): $mol_view
		Head_queries( ): $mol_view
		Head_subtasks( ): $mol_view
		Head_date( ): $mol_view
		Head_daily( ): $mol_view
		Table_head( ): $mol_view
		task_rows( ): readonly(any)[]
		Rows( ): $mol_list
		Table( ): $mol_view
		Content( ): $mol_view
		task_uri( id: any): string
		task_title( id: any): string
		Task_title( id: any): $mol_link
		task_queries( id: any): string
		Task_queries( id: any): $mol_view
		task_subtasks( id: any): string
		Task_subtasks( id: any): $mol_view
		task_date( id: any): string
		Task_date( id: any): $mol_view
		task_daily( id: any, next?: boolean ): boolean
		Task_daily( id: any): $mol_check_box
		task_id( next?: string ): string
		title( ): string
		head( ): readonly(any)[]
		body( ): readonly(any)[]
		Task( id: any): $mol_view
		Empty( ): $mol_view
	}
	
}

//# sourceMappingURL=catalog.view.tree.d.ts.map